import Splide from '@splidejs/splide';

export const initInstallSlider = () => {
  new Splide('[data-switch-installation-install-slider]', {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    speed: 600,
    rewind: true,
    arrows: false,
    pagination: true,
    gap: 30,
    classes: {
      pagination: 'switch-installation-install__slider-pagination',
      page: 'switch-installation-install__slider-pagination-btn',
    },
  }).mount();
};
